export const painPoints: string[] = [
  'Hours spent searching for drills and lesson ideas',
  'Repeating the same exercises because they are the ones you already know',
  'Wondering what progression should come next',
  'Struggling to adapt a lesson when a swimmer progresses faster or slower than expected',
  'Mixed-level classes that become difficult to organize',
  'Seeing a technique problem but not immediately knowing the best cue or correction',
  'Starting every new lesson with another blank page',
  'Taking lesson planning home with you after your teaching day is already finished',
]
